import React from 'react';
import { BsThreeDots } from 'react-icons/bs';
import { MdCheckCircleOutline, MdHistory, MdOutlineCancel } from 'react-icons/md';

import Dropdown from 'components/dropdown';

function InvoiceMenu(props: {
    invoice: any;
    updateInvoiceStatus: any;
    createCreditNote: any;
    disabled?: boolean;
    openHistory?: any;
    isLastItem?: boolean;
}) {
    const { invoice, updateInvoiceStatus, createCreditNote, disabled, openHistory, isLastItem } = props;
    const [open, setOpen] = React.useState(false);

    return (
        <Dropdown
            button={
                <button
                    onClick={() => !disabled && setOpen(!open)}
                    className={`flex items-center rounded-lg p-1.5 transition-colors duration-100 ${
                        disabled
                            ? 'cursor-not-allowed text-gray-300'
                            : 'text-gray-400 hover:bg-lightPrimary hover:text-toola-500'
                    }`}
                >
                    <BsThreeDots className="h-5 w-5" title="Autres actions" />
                </button>
            }
            animation="origin-top-right transition-all duration-200 ease-out"
            classNames={`${isLastItem ? 'bottom-1 right-8' : 'top-11'} right-0 w-max`}
            children={
                <div className="z-50 w-52 rounded-2xl bg-white py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
                    {open && (
                        <>
                            <button
                                className="flex w-full items-center gap-2.5 px-4 py-2.5 text-sm text-gray-600 transition-colors hover:bg-lightPrimary hover:text-navy-700 dark:text-gray-300 dark:hover:bg-navy-600"
                                onClick={() => {
                                    updateInvoiceStatus(invoice);
                                    setOpen(false);
                                }}
                            >
                                <MdCheckCircleOutline className="h-4 w-4 shrink-0 text-toola-500" />
                                {invoice.status === 'paid' ? 'Voir les transactions' : 'Marquer comme payé'}
                            </button>
                            <button
                                className="flex w-full items-center gap-2.5 px-4 py-2.5 text-sm text-gray-600 transition-colors hover:bg-lightPrimary hover:text-navy-700 dark:text-gray-300 dark:hover:bg-navy-600"
                                onClick={() => {
                                    openHistory(invoice);
                                    setOpen(false);
                                }}
                            >
                                <MdHistory className="h-4 w-4 shrink-0 text-toola-500" />
                                Historique d'envoi
                            </button>
                            {invoice.type !== 'credit-note' && invoice.status !== 'canceled' && (
                                <>
                                    <div className="mx-4 my-1 border-t border-gray-100 dark:border-white/10" />
                                    <button
                                        className="flex w-full items-center gap-2.5 px-4 py-2.5 text-sm text-red-500 transition-colors hover:bg-red-50 dark:hover:bg-red-900/20"
                                        onClick={() => {
                                            createCreditNote(invoice.id);
                                            setOpen(false);
                                        }}
                                    >
                                        <MdOutlineCancel className="h-4 w-4 shrink-0" />
                                        Annuler la facture
                                    </button>
                                </>
                            )}
                        </>
                    )}
                </div>
            }
        />
    );
}

export default InvoiceMenu;
